<template>
  <div>
    <banners />
  </div>
</template>

<script>
import Banners from '@/components/Affiliates/Banners'

export default {
  name: 'AffiliatesBanners',
  components: {
    Banners,
  },
}
</script>
